import { Routes } from '@models/route';
import { lazy } from 'react';

const ContactListing = lazy(() => import('@pages/contacts/ContactList').then((p) => ({ default: p.ContactList })));
const ContactDetail = lazy(() =>
  import('@pages/contacts/ContactDetail').then((p) => ({
    default: p.ContactDetail
  }))
);

export const ContactRoutes: Routes = [
  {
    path: 'admin/contacts',
    component: ContactListing,
    children: [
      {
        path: 'create',
        component: ContactDetail
      },
      {
        path: ':id',
        component: ContactDetail
      }
    ]
  }
];
